<template>
  <v-layout row>
    <v-flex xs10 sm11 md11>
      <v-text-field v-if="showInputTags"
        :rules="rules"
        @blur="blurTextfield"
        @keydown.enter="blurTextfield"
        v-model="tagString"
        autofocus
      ></v-text-field>
      <div id="tag-box" v-if="!showInputTags"  @click="addTag()">
        <div v-for="(chip, index) in model" :key="index">
           <span class="chips" @input="removeItem(chip)">
            {{ chip }}
            <v-icon small @click="deleteTag(chip)" class="ml-2">cancel</v-icon>
          </span>
        </div>
      </div>
    </v-flex>
    <v-flex text-xs-center xs2 sm1 md1>
      <v-btn color="accent" flat icon @click="doSearch">
        <v-icon>search</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>
<script>
import ErrorMessage from "@/components/parts/ApiErrorMessage.vue";

export default {
  components: {
    ErrorMessage
  },
  data() {
    return {
      words: [],
      search: "",
      isDisabled: true,
      rules: [v => !!v || "検索ワードを入力してください"],
      tagString: "",
      showInputTags: false,
      isDelete: false
    };
  },
  computed: {
    model: {
      get() {
        return this.$store.getters.getSearchWords;
      },
      set(val) {
        this.words = val
          .join(" ")
          .split(/\s+/)
          .filter(word => word.trim());
        // 重複してるキーワードを削除
        this.words = [...new Set(this.words)];
        this.$store.commit("setSearchWords", this.words);
      }
    }
  },
  methods: {
    doSearch() {
      if (this.model.length <= 0 && this.model.length > 10) {
        return false;
      }

      // フォーカスが外れればstoreが更新されるため、特に何もしない
      const params = new URLSearchParams();
      for (const word of this.model) {
        params.append("q", word);
      }

      this.$http
        .get("/v1/graphs/search", {
          params: params
        })
        .then(res => {
          this.$store.commit("setSearchResult", res.data);
          this.$router.push({ name: "search-result" });
        })
        .catch(error => {
          this.$refs.errorDialog.setMessage(
            "グラフの検索に失敗しました。詳細：[" +
              error.response.status +
              "] " +
              error.response.statusText
          );
          this.$store.commit("setSearchResult", () => []);
        });

      this.$emit("click");
    },
    blurTextfield(e) {
      if (e.isComposing) {
        return false;
      }
      let tmpWords = [];

      // テキストフィールドに文字列が入っていたら、半角空白で分割する
      if (this.tagString && this.tagString.length !== 0) {
        // テキストフィールドに入っている文字列を、半角空白で分割し配列にする
        tmpWords = this.tagString.split(/( |　)+/);
      }

      // tmpWordsの中に、空白のみの要素があったら削除
      tmpWords = tmpWords.filter(w => w.trim());

      // 重複しているキーワードを削除
      tmpWords = [...new Set(tmpWords)];

      this.model = tmpWords;
      this.showInputTags = false;
    },
    removeItem(tag) {
      const chips = this.model;
      const index = chips.findIndex(w => w === tag);
      if (index === -1) {
        return false;
      }
      this.model.splice(index, 1);
    },
    deleteTag(item) {
      this.isDelete = true;
      const index = this.model.indexOf(item);
      if(index === -1) {
        return false;
      }
      this.model.splice(index, 1);
    },
    addTag() {
      if(this.isDelete) {
        this.isDelete = false;
        return false;
      }
      this.tagString = this.model.join(" ");
      this.showInputTags = true;
    }
  }
};
</script>
<style scoped lang="scss">
#tag-box {
  height: 40px;
  overflow-x: scroll;
  display: flex;
  border: solid 1px #999999;
  border-radius: 3px;
  div {
    display: inline-block;
    height: 80%;
    span.chips {
      background: #e0e0e0;
      color: rgba(0,0,0,0.87);
      padding: 2px 12px;
      border-radius: 2px;
      margin: 4px;
      display: flex;
      height: 100%;
      font-size: 16px;
      white-space: nowrap;
    }
  }
}
</style>